import React from "react";
import { Link ,useNavigate } from "react-router";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { useDispatch,useSelector  } from "react-redux";
import Pagination from "../../common/Pagination";
import SearchBar from "../../common/Search";
import { setAmenitiesFilters } from "../../redux/features/filtersSlice";
import { openModal } from "../../redux/features/modalSlice";
import {useGetAmenitiesQuery} from "../../redux/services/AmenitiesService/amienities.Services";

function Amenities() {
  const dispatch = useDispatch();
const navigate = useNavigate();
const filters = useSelector((state) => state.filters.Amenities);
  const { data, isLoading, isError } = useGetAmenitiesQuery(filters);
  const amenitiesData = data?.data || [];
const pagination = data?.pagination || {};
const totalPages =pagination?.totalPages || 0;
const showPagination = totalPages > 1;
const isActive = (status) => {
  return String(status).toLowerCase() === "active";
};

const handlePageChange = (page) => {
  dispatch(
    setAmenitiesFilters({
      page,
    })
  );
};

const handleSearch = (value) => {
  dispatch(
    setAmenitiesFilters({
      search: value,
      page: 1,
    })
  );
};

  if (isLoading) return <h3>Loading...</h3>;

  return (
    <div>
      {/* HEADER */}
      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              All Amenties List
            </h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">
                  Home
                </Link>
              </li>

              <li className="breadcrumb-item active">
                Amenties List
              </li>
            </ol>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            className="btn btn-primary"
            // onClick={() =>
            //   dispatch(
            //     openModal({
            //       type: "create",
            //       title: "Create Amenties",
            //       data: {
            //         refresh: true
            //       }
            //     })
            //   )
            // }
            onClick={() =>
  navigate("/add-amenities")
}
          >
            + Add Amenties
          </button>
        </div>
        <div className="mb-3">
  <SearchBar
    search={filters.search}
    setSearch={handleSearch}
    placeholder="Search Amenities..."
  />
</div>
      </div>

      {/* TABLE */}
      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
             <th>Image</th>
            <th>Status</th>
            <th>Change Status</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          {amenitiesData.map((item,index) => (
          <tr key={item._id || item.id}>
                 <td> {(index + 1) + (filters.page - 1) * filters.limit}</td>
              <td>{item.name}</td>
                <td>
                    <img
                      src={`${data?.imageBaseUrl}${item.image}`}
                      alt={item.name}
                      width="50"
                      height="50"
                      style={{
                        objectFit: "cover",
                        borderRadius: "8px"
                      }}
                    />
                  </td>
 
<td>
  {isActive(item.status) ? "Active" : "Inactive"}
</td>
<td style={{ width: "150px" }}>
  <div className="city-status-switch">

    {/* CHANGE STATUS INPUT */}

    <input
      type="checkbox"
      id={`status-${item._id || item.id}`}
      className="city-status-input"
   checked={isActive(item.status)}
      onChange={() =>
        dispatch(
          openModal({
            type: "status-amenities",
            title: "Change Amenities Status",
            data: {
              id: item._id || item.id,
              name: item.name,
              status: item.status,
              apiUrl: "/amenities-status",
              message: `You want to change status of ${item.name}`,
            },
          })
        )
      }
    />

    <label
      htmlFor={`status-${item._id || item.id}`}
      className="city-status-label"
    >
      <span className="city-status-ball"></span>

      <span className="city-status-text">
      {isActive(item.status) ? "Active" : "Inactive"}
      </span>
    </label>

  {/* {isActive(item.status) ? "Active" : "Inactive"} */}

  </div>
</td>
              {/* ACTION */}
              <td className="text-center">

                {/* VIEW (GLOBAL MODAL) */}
                <button
                  className="st-action-btn st-delete-btn"
                  onClick={() =>
                    dispatch(
                      openModal({
                        type: "view-amenities",
                        title: "View Amenities",
                        data: item,
                      })
                    )
                  }
                >
                  <FaEye />
                </button>

                {/* EDIT (GLOBAL MODAL) */}
                <button
                  className="st-action-btn st-view-btn"
                  onClick={() =>
                    dispatch(
                      openModal({
                        type: "edit-amenities",
                        title: "Edit Amenities",
                        data: item,
                      })
                    )
                  }
                >
                  <FaEdit />
                </button>

<button
  className="st-action-btn st-edit-btn"
  onClick={() =>
    dispatch(
      openModal({
        type: "delete-amenities",
        title: "Delete Amenities",
        data: {
          id: item._id || item.id,
          apiUrl: "/amenities-delete",
           useBody: true,
          message: `You are deleting ${item.name}`,
        },
      })
    )
  }
>
  <FaTrash />
</button>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-end mt-4">

  {showPagination && (
    <Pagination
      page={filters.page}
      totalPages={totalPages}
      onPageChange={handlePageChange}
    />
  )}

</div>
    </div>
  );
}

export default Amenities;